'use client'

import { useCallback } from 'react'
import { usePathname } from 'next/navigation'
import { ButtonOrLink } from '@/components/ButtonOrLink'
import s from './Navbar.module.scss'
import { classnames } from '@/utils/classnames'

const normalizePath = (path: string) => path.replace(/\/+$/, '') || '/'

type NavItemProps = {
  text: string
  href: string
  active: boolean
  /** Zamyka menu mobilne — jak przy kliknięciu logo na tej samej stronie */
  onCloseNav?: () => void
}

const NavItem = ({
  text,
  href,
  active = false,
  onCloseNav,
}: NavItemProps) => {
  const pathname = usePathname()

  const handleLinkClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (normalizePath(pathname) === normalizePath(href)) {
        e.preventDefault()
        window.scrollTo({ top: 0, behavior: 'smooth' })
        onCloseNav?.()
      }
    },
    [pathname, href, onCloseNav],
  )

  return (
    <ButtonOrLink
      as="link"
      href={href}
      variant="menuLink"
      classes={classnames(s.linkContainer, s.pulseLink)}
      buttonColor="transparent"
      onClick={handleLinkClick}
    >
      <span
        className={s.linkContent}
        style={{ display: 'inline-flex', alignItems: 'center' }}
      >
        <div className={classnames(s.dot, { [s.active]: active })} />
        <span className={classnames(s.link, { [s.active]: active })}>
          {text}
        </span>
      </span>
    </ButtonOrLink>
  )
}

export default NavItem
